import { render } from "./PlansView.vue?vue&type=template&id=084e4d48&scoped=true"
import script from "./PlansView.vue?vue&type=script&lang=js"
export * from "./PlansView.vue?vue&type=script&lang=js"

import "./PlansView.vue?vue&type=style&index=0&id=084e4d48&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084e4d48"]])

export default __exports__